module.exports = __webpack_public_path__ + "img/detail-gonglue.5d71e9cd.svg";